import { NavLink, Outlet } from "react-router-dom";
import { LayoutGrid, Film, Users, MessageSquareText, Hash, Sparkles, Settings, MessageCircle, Swords, LineChart as LineChartIcon, CalendarDays, Lightbulb } from "lucide-react";
import { useApi } from "@/lib/api";

const NAV = [
  { to: "/", label: "Panoramica", icon: LayoutGrid, id: "overview" },
  { to: "/contenuti", label: "Post & Reel", icon: Film, id: "content" },
  { to: "/pubblico", label: "Pubblico", icon: Users, id: "audience" },
  { to: "/commenti", label: "Commenti", icon: MessageSquareText, id: "comments" },
  { to: "/hashtag", label: "Hashtag & Trend", icon: Hash, id: "hashtags" },
  { to: "/concorrenti", label: "Concorrenti", icon: Swords, id: "competitors" },
  { to: "/storico", label: "Storico", icon: LineChartIcon, id: "history" },
  { to: "/strategia", label: "Strategia AI", icon: Sparkles, id: "strategy" },
  { to: "/calendario", label: "Calendario", icon: CalendarDays, id: "calendar" },
  { to: "/idee", label: "Archivio idee", icon: Lightbulb, id: "ideas" },
  { to: "/impostazioni", label: "Impostazioni", icon: Settings, id: "settings" },
];

const ModeBadge = ({ mode }) => (
  <span data-testid="mode-badge" className={`inline-flex items-center gap-1.5 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider border ${mode === "live" ? "border-[#2A4B3C] text-[#2A4B3C]" : "border-[#C05C3D] text-[#C05C3D]"}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${mode === "live" ? "bg-[#2A4B3C]" : "bg-[#C05C3D]"} animate-pulse`} />
    {mode === "live" ? "Dati live Meta" : "Modalità demo"}
  </span>
);

export default function Layout() {
  const { data } = useApi("/status");
  return (
    <div className="grain min-h-screen flex">
      <aside className="w-60 shrink-0 border-r border-[#E8E8E4] bg-[#FFFFFF] hidden md:flex flex-col sticky top-0 h-screen">
        <div className="px-6 py-6 border-b border-[#E8E8E4]">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#2A4B3C] flex items-center justify-center"><MessageCircle className="w-4 h-4 text-[#F7F7F5]" /></div>
            <div>
              <div className="font-display font-semibold text-lg leading-none">EasyHost</div>
              <div className="label mt-1 !text-[9px]">Social Lab</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map(({ to, label, icon: Icon, id }) => (
            <NavLink key={to} to={to} end data-testid={`nav-link-${id}`}
              className={({ isActive }) => `flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 transition-colors ${isActive ? "border-[#2A4B3C] bg-[#F1F3EF] text-[#2A4B3C] font-semibold" : "border-transparent text-[#5C5C58] hover:text-[#1C1C1A] hover:bg-[#F7F7F5]"}`}>
              <Icon className="w-4 h-4" strokeWidth={1.75} />{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-6 border-t border-[#E8E8E4]">{data && <ModeBadge mode={data.mode} />}</div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="md:hidden sticky top-0 z-40 bg-[#FFFFFF] border-b border-[#E8E8E4] overflow-x-auto flex">
          {NAV.map(({ to, label, id }) => (
            <NavLink key={to} to={to} end data-testid={`mnav-link-${id}`} className={({ isActive }) => `px-4 py-3 text-xs whitespace-nowrap ${isActive ? "text-[#2A4B3C] font-semibold border-b-2 border-[#2A4B3C]" : "text-[#5C5C58]"}`}>{label}</NavLink>
          ))}
        </header>
        <main className="px-6 md:px-10 py-8 max-w-[1500px]"><Outlet /></main>
      </div>
    </div>
  );
}
